import { render, staticRenderFns } from "./AddToListButton.vue?vue&type=template&id=1f388aaa"
import script from "./AddToListButton.vue?vue&type=script&lang=js"
export * from "./AddToListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports